import * as React from 'react';
import { AccountSelect } from '../../../../components/AccountSelect';
import { AccountSelectV2 } from '../../../../components/AccountSelectV2';
import { EActiveView } from '../../../../types/view';
import { trackAccountSelectOpen } from '../../tracking';
import { jsx as _jsx } from "react/jsx-runtime";
export var AccountSelectContainer = function AccountSelectContainer(_ref) {
  var view = _ref.view,
    source = _ref.source,
    phone = _ref.phone,
    accounts = _ref.accounts,
    phoneАccounts = _ref.phoneАccounts,
    loadableAccount = _ref.loadableAccount,
    continueByAccount = _ref.continueByAccount,
    continueByPhone = _ref.continueByPhone,
    changeView = _ref.changeView,
    continueByAccountLoading = _ref.continueByAccountLoading,
    continueByPhoneLoading = _ref.continueByPhoneLoading,
    isRedesignExperimentEnabled = _ref.isRedesignExperimentEnabled;
  React.useEffect(function () {
    if (isRedesignExperimentEnabled) {
      var button = phoneАccounts.length === 0 ? 'create_by_phone' : null;
      trackAccountSelectOpen(source, button);
    }
  }, []);
  var handleSelectAccount = function handleSelectAccount(account) {
    if (account) {
      continueByAccount({
        email: account.email,
        phone: account.phone
      });
    } else {
      continueByPhone();
    }
  };
  var handleSwitchToRegistration = React.useCallback(function () {
    changeView(EActiveView.Agreement, {
      prevView: view.active,
      prevData: view.data,
      phone: phone
    });
  }, [changeView, phone, view]);
  if (isRedesignExperimentEnabled) {
    return /*#__PURE__*/_jsx(AccountSelectV2, {
      phone: phone,
      accounts: accounts,
      phoneАccounts: phoneАccounts,
      loadableAccount: loadableAccount,
      continueByPhoneLoading: continueByPhoneLoading,
      continueByAccountLoading: continueByAccountLoading,
      onAccountSelect: handleSelectAccount,
      switchToRegistration: handleSwitchToRegistration
    });
  }
  return /*#__PURE__*/_jsx(AccountSelect, {
    accounts: accounts,
    phoneАccounts: phoneАccounts,
    loadableAccount: loadableAccount,
    continueByPhoneLoading: continueByPhoneLoading,
    continueByAccountLoading: continueByAccountLoading,
    onAccountSelect: handleSelectAccount
  });
};